var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 2.5H4.1665C2.98817 2.5 2.399 2.5 2.03317 2.84333C1.6665 3.18667 1.6665 3.74 1.6665 4.84583V5.42083C1.6665 6.285 1.6665 6.7175 1.88317 7.07583C2.09984 7.43417 2.494 7.6575 3.28484 8.1025L5.71234 9.46917C6.24234 9.7675 6.50817 9.91667 6.69817 10.0817C7.09317 10.4242 7.3365 10.8275 7.4465 11.3233C7.49984 11.56 7.49984 11.8383 7.49984 12.3942V14.6192C7.49984 15.3767 7.49984 15.7558 7.70984 16.0508C7.91984 16.3467 8.29317 16.4925 9.03817 16.7842C10.604 17.3958 11.3865 17.7017 11.9432 17.3533C12.4998 17.0058 12.4998 16.21 12.4998 14.6183V12.3933C12.4998 11.8383 12.4998 11.56 12.5532 11.3225C12.6578 10.8368 12.9215 10.3999 13.3023 10.0808C13.4915 9.91667 13.7573 9.7675 14.2873 9.46833L16.7148 8.10167C17.5048 7.6575 17.9007 7.435 18.1165 7.07667C18.3332 6.71833 18.3332 6.285 18.3332 5.42V4.845C18.3332 3.74 18.3332 3.18667 17.9665 2.84333C17.6015 2.5 17.0123 2.5 15.8332 2.5Z",
    stroke: "#AFA9A9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d6c2d0492cbc211dc9023c94c0791c56.svg";
export { ForwardRef as ReactComponent };